import React, { FC } from 'react'
import {
  ModuleContext,
  Module,
  ModuleGroupCardTabs,
  GroupCardTab,
  ModuleTabs,
  Tab,
} from '../types'
import { useProductStore } from '../../contexts/product'
import { useTracking } from '../../contexts/tracking'
import { TabsModule } from '../Tabs'

type Props = {
  tabModule: ModuleGroupCardTabs
  context: ModuleContext
  mapModule: (module: Module, props: ModuleContext) => React.JSX.Element | null
}

export const GroupCardTabsModule: FC<Props> = ({
  tabModule,
  context,
  mapModule,
}) => {
  const [_, productStoreDispatcher] = useProductStore()
  const { selectContent } = useTracking()

  const handleOnChanged = (tab: Tab) => {
    productStoreDispatcher.setIsGroupCardSelected(
      (tab as GroupCardTab).type === 'GROUP',
    )
    selectContent({
      action: tabModule.meta.intent,
      component: 'tab',
      label: tab.title,
    })
  }

  return (
    <TabsModule
      context={context}
      module={tabModule as unknown as ModuleTabs}
      mapModule={mapModule}
      onChanged={handleOnChanged}
      data-testid="module-group-card-tabs"
    />
  )
}
